import type { AnalysisResult } from '../lib/types';
import { mockEarningsCall } from './mock-earnings-call';
import { mock10K } from './mock-10k';
import { mockCredit } from './mock-credit';

export const SAMPLES: AnalysisResult[] = [mockEarningsCall, mock10K, mockCredit];

export function findResultBySlug(slug: string): AnalysisResult | undefined {
  return SAMPLES.find((s) => s.slug === slug);
}

export { mockEarningsCall, mock10K, mockCredit };
